import Form from '~/components/form'
import React from 'react'

export const PartnersForm: React.FC = () => {
  return (
    <div className='onlinepbx__partners__form'>
      <div className='onlinepbx__container'>
        <h2 className='onlinepbx__partners__form__header'>
          Начните зарабатывать c <span
            className='onlinepbx__content__header__green'>online</span>
          <span
            className='onlinepbx__content__header__black'>pbx</span>!
        </h2>
        <div className='onlinepbx__partners__form__content'>
          <div className='onlinepbx__partners__form__block'>
            <Form
              isWhite
              text='Стать партнером'
              pageName='Партнерам'
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default PartnersForm
